export class Field {
  id: number;
  constructor(id: number) {
    this.id = id;
  }
}
